// Auto-generated entry for struct// import './../../struct.scss';

// Includes general styles and scripts
import './initial';

import '../js/vendor/snap-slider.min.js';
import '../js/src/opc.scroll-slider.js';

import '../js/src/vendor/script/opacc.struct';
import '../js/src/vendor/script/opacc.filter';

import '@scss/modules/struct.scss';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKTabs from '@tk/controls/tk.tabs.tab';
import TKCarousel from '@tk/components/tk.carousel';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';

export default class General extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-tabs-tab', constructor: TKTabs },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
        ]);
    }
}

new General();
